"use client";

import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import styles from "rivals/components/pages/Article/Article.module.scss";

export default function RightRail({
  children
}: {
  children?: React.ReactNode;
}): JSX.Element {
  const INITIAL_TOP_VALUE = 100;
  const railRef = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState(INITIAL_TOP_VALUE);

  useEffect(() => {
    const syncRailTop = (): void => {
      if (rail) {
        resizeObserver.observe(rail);

        const computedStyles: CSSStyleDeclaration = window.getComputedStyle(
          rail
        );
        const railHeight = ["margin-top", "margin-bottom", "height"].reduce(
          (height, property) =>
            height + parseInt(computedStyles.getPropertyValue(property)),
          0
        );
        const windowHeight = window.innerHeight;

        setTop(
          windowHeight - INITIAL_TOP_VALUE < railHeight
            ? window.innerHeight - railHeight
            : INITIAL_TOP_VALUE
        );
      }
    };

    const resizeObserver = new ResizeObserver(syncRailTop);

    const rail = railRef.current;

    syncRailTop();

    addEventListener("resize", syncRailTop);

    return (): void => {
      removeEventListener("resize", syncRailTop);
      if (rail) {
        resizeObserver.unobserve(rail);
      }
    };
  }, [railRef]);

  return (
    <div
      className={classNames([styles.rail, styles.right])}
      ref={railRef}
      style={{ top }}
    >
      {children}
    </div>
  );
}
